export type LegacyWorkScheduleFormType =
  | 'l_scheduleTypeGeneral'
  | 'l_scheduleTypeWorkDaily'
  | 'l_scheduleTypeShootingWait'
  | 'l_scheduleTypeShoot'

export type LegacyWorkScheduleChoice = {
  id: string
  label: string
}

export type LegacyWorkScheduleCustomer = {
  id: string
  customerNo: string
  babyName: string
  guardianName: string
  officeName: string
}

export const legacyWorkScheduleFormOffice = {
  id: 'mock-office',
  name: 'Mock 지점',
}

export const legacyWorkScheduleFormStaff: LegacyWorkScheduleChoice[] = [
  { id: 'mock-staff-01', label: 'Mock 담당자 01' },
  { id: 'mock-staff-02', label: 'Mock 담당자 02' },
  { id: 'mock-staff-03', label: 'Mock 담당자 03' },
  { id: 'mock-staff-04', label: 'Mock 담당자 04' },
]

export const legacyWorkScheduleFormGroups: LegacyWorkScheduleChoice[] = Array.from({ length: 10 }, (_, index) => ({
  id: `mock-workgroup-${String(index + 1).padStart(2, '0')}`,
  label: `Mock 작업담당 ${String(index + 1).padStart(2, '0')}`,
}))

export const legacyWorkScheduleFormCustomers: LegacyWorkScheduleCustomer[] = [
  { id: 'mock-customer-01', customerNo: 'MOCK-0001', babyName: 'Mock 아기 01', guardianName: 'Mock 보호자 01', officeName: 'Mock 지점' },
  { id: 'mock-customer-02', customerNo: 'MOCK-0002', babyName: 'Mock 아기 02', guardianName: 'Mock 보호자 02', officeName: 'Mock 지점' },
  { id: 'mock-customer-03', customerNo: 'MOCK-0003', babyName: 'Mock 아기 03', guardianName: 'Mock 보호자 03', officeName: 'Mock 지점 B' },
]

export const legacyWorkScheduleEditRecord = {
  type: 'l_scheduleTypeWorkDaily' as LegacyWorkScheduleFormType,
  title: 'Mock 업무 일정',
  date: '2026-08-29',
  startTime: '09:00',
  endTime: '10:00',
  colorIndex: 1,
  statusIndex: 1,
  memo: 'Mock 일정 메모',
  content: '운영 데이터와 연결되지 않은 Mock 직원 내용입니다.',
  staffId: 'mock-staff-01',
  workgroupId: 'mock-workgroup-01',
  customerId: 'mock-customer-01',
  insertedAt: '2026-08-28 09:00 Mock 담당자',
  updatedAt: '2026-08-29 10:00 Mock 담당자',
}

export const legacyWorkScheduleHistory = [
  { id: 'mock-history-01', changedAt: '2026-08-29 10:00', changedBy: 'Mock 담당자', summary: 'Mock 일정 내용 수정' },
  { id: 'mock-history-02', changedAt: '2026-08-28 09:00', changedBy: 'Mock 담당자', summary: 'Mock 일정 최초 등록' },
]
